export function formatSaleDisplayId(saleNumber) {
  return saleNumber?.replace(/^(PURCHASE|UNIFORM)-/, "") || "-";
}

export function saleTypeLabel(saleType) {
  if (saleType === "uniforms") return "Uniform";
  return "Book";
}
